const COLOR_ORDER = ['W', 'U', 'B', 'R', 'G'];
/**
 * Compute the union color identity from multiple commanders.
 * Returns colors in WUBRG order.
 */
export function computeColorIdentity(commanderIdentities) {
    const set = new Set();
    for (const identity of commanderIdentities) {
        for (const color of identity) {
            set.add(color);
        }
    }
    return COLOR_ORDER.filter((c) => set.has(c));
}
/**
 * Returns true if a card's color identity is a subset of the allowed identity.
 */
export function isWithinColorIdentity(cardColors, allowedColors) {
    const allowed = new Set(allowedColors);
    return cardColors.every((c) => allowed.has(c));
}
/**
 * Build a Scryfall color identity filter string, e.g. "id<=WUBRG" or "id:c"
 */
export function toScryfallIdentityFilter(colors) {
    if (colors.length === 0)
        return 'id:c';
    return `id<=${colors.join('')}`;
}
/**
 * Returns true if the card's color identity is a subset of the deck's color identity.
 * A card with an empty colorIdentity (colorless) is legal in every deck.
 * @param cardColorIdentity - The card's color identity.
 * @param deckColorIdentity - The deck's commander color identity.
 * @returns true if the card is color-legal for the deck.
 */
export function isCardColorLegal(cardColorIdentity, deckColorIdentity) {
    if (cardColorIdentity.length === 0)
        return true;
    return cardColorIdentity.every((c) => deckColorIdentity.includes(c));
}
export function colorName(color) {
    const names = {
        W: 'White',
        U: 'Blue',
        B: 'Black',
        R: 'Red',
        G: 'Green',
    };
    return names[color];
}
//# sourceMappingURL=color-identity.js.map